import React, { useState, useRef, useEffect } from 'react';
import { useTour } from '../contexts/TourContext';
import { deckTours } from '../tours/deckTours';

const ToursMenu = ({ isCanvas = false }) => {
  const { startTour } = useTour();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleTourClick = (tourId) => {
    startTour(tourId);
    setIsOpen(false);
  };

  const buttonStyle = isCanvas
    ? {
      // Floating style for Canvas matching back button
      background: 'rgba(30, 41, 59, 0.7)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: 10,
      width: 42,
      height: 42,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: '20px',
      color: '#fff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      transition: 'all 0.2s',
      padding: 8,
      margin: 0,
      boxSizing: 'border-box'
    }
    : {
      // Dashboard style
      background: 'rgba(99, 102, 241, 0.1)',
      border: '1px solid rgba(99, 102, 241, 0.3)',
      borderRadius: '8px',
      padding: '8px 16px',
      color: '#6366f1',
      fontWeight: 600,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s',
    };

  const menuStyle = {
    position: 'absolute',
    top: '100%',
    bottom: 'auto',
    right: isCanvas ? 'auto' : 0,
    left: isCanvas ? 0 : 'auto',
    marginTop: '8px',
    marginBottom: 0,
    background: 'rgba(15, 23, 42, 0.95)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    padding: '8px',
    minWidth: '220px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
    zIndex: 10000,
    display: isOpen ? 'block' : 'none',
  };

  const itemStyle = {
    padding: '10px 16px',
    cursor: 'pointer',
    borderRadius: '6px',
    color: '#f8fafc',
    transition: 'background 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  return (
    <div style={{ position: 'relative' }} id="tour-tours-btn">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        style={buttonStyle}
        onMouseEnter={(e) => {
          if (isCanvas) {
            e.currentTarget.style.background = 'rgba(30, 41, 59, 0.9)';
            e.currentTarget.style.transform = 'scale(1.05)';
          } else {
            e.currentTarget.style.background = 'rgba(99, 102, 241, 0.2)';
          }
        }}
        onMouseLeave={(e) => {
          if (isCanvas) {
            e.currentTarget.style.background = 'rgba(30, 41, 59, 0.7)';
            e.currentTarget.style.transform = 'scale(1)';
          } else {
            e.currentTarget.style.background = 'rgba(99, 102, 241, 0.1)';
          }
        }}
        title="Guided Tours"
      >
        {isCanvas ? '🗺️' : '🗺️ Guided Tours'}
      </button>

      <div ref={menuRef} style={menuStyle}>
        <div style={{ padding: '8px 12px', fontSize: '12px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
          Available Tours
        </div>

        <div
          style={itemStyle}
          onClick={() => handleTourClick('intro')}
          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          ✨ Introduction Tour
        </div>

        <div style={{ height: '1px', background: 'rgba(255, 255, 255, 0.1)', margin: '4px 0' }} />

        {deckTours.map((tour) => (
          <div
            key={tour.id}
            style={itemStyle}
            onClick={() => handleTourClick(tour.id)}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            {tour.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToursMenu;
